module.exports = __webpack_public_path__ + "media/images/homes/gift_card-96d00a3e3061e8448ff6a59b72c827ef.svg";